import React from 'react'
import Font from '@cred/react-font'
import { Link } from '@cred/react-link'
import styles from './styles.scss'

const disclaimers = {
  citizens: (
    <Link
      href="https://www.citizensbank.com/student-lending/DisclosureHub.aspx#rate-lowest"
      blank
    >
      VIEW CITIZENS BANK DISCLOSURES ON THEIR WEBSITE
    </Link>
  ),
  cas: (
    <>
      <Font type="disclaimer" className={styles.disclaimerText}>
        College Ave Student Loans products are made available through either Firstrust Bank, member
        FDIC or M.Y. Safra Bank, FSB, member FDIC. All loans are subject to individual approval and
        adherence to underwriting guidelines. Program restrictions, other terms, and conditions
        apply.
        <br />
        (2)All rates shown include the autopay discount. The 0.25% auto-pay interest rate reduction
        applies as long as the borrower or cosigner, if applicable, enrolls in auto-pay and
        authorizes our loan servicer to automatically deduct your monthly payments from a valid bank
        account via Automated Clearing House (“ACH”). The rate reduction applies for as long as the
        monthly payment amount is successfully deducted from the designated bank account and is
        suspended during periods of forbearance and certain deferments. Variable rates may increase
        after consummation.
        <br />
        (3)$5,000 is the minimum requirement to refinance. The maximum loan amount is $300,000 for
        those with medical, dental, pharmacy or veterinary doctorate degrees, and $150,000 for all
        other undergraduate or graduate degree.
        <br />
        (4)This informational repayment example uses typical loan terms for a refi borrower with a
        Full Principal &amp; Interest Repayment and a 10-year repayment term, has a $40,000 loan and
        a 5.5% Annual Percentage Rate (“APR”): 120 monthly payments of $434.11 while in the
        repayment period, for a total amount of payments of $52,092.61. Loans will never have a full
        principal and interest monthly payment of less than $50. Your actual rates and repayment
        terms may vary.
        <br />
        Information advertised valid as of 12/14/2020. Variable interest rates may increase after
        consummation.
      </Font>
    </>
  ),
  invested: (
    <>
      <Font type="disclaimer" className={styles.disclaimerText}>
        Subject to credit approval, loans are made by INvestEd or Bank of Lake Mills. Bank of Lake
        Mills does not have an ownership interest in INvestEd. Bank of Lake Mills is Member FDIC.
        <br />
        1 These rates are expressed as APR.
        <br />
        Rates shown are for eligible, creditworthy applicants and requires shortest length of
        repayment and our Automatic Payment discount of 0.25 percentage points. Automatic payments
        are not required. Annual percentage rates (APR) listed are based on borrowing $10,000 in a
        single disbursement.
        <br />
        The Fixed rate will not change during the term.
        <br />
        The variable rate is subject to increase after consummation. The maximum variable interest
        rate is 18.00%. The variable interest rate that is charged to the borrower is reset
        quarterly, may increase or decrease, and is based on an Index and Margin. That means that
        your rate could move lower or higher than the rates on this form. The variable rate is based
        upon an average of the 3-month London Interbank Offered Rate (LIBOR) as published in the
        Wall Street Journal.
      </Font>
    </>
  ),
  elfi: (
    <>
      <Font type="disclaimer" className={styles.disclaimerText}>
        Terms and conditions apply.{' '}
        <Link href="https://www.elfi.com/terms" blank>
          https://www.elfi.com/terms
        </Link>
      </Font>
    </>
  ),
  sofi: (
    <>
      <Font type="disclaimer" className={styles.disclaimerText}>
        Fixed rates from 2.99% APR (with AutoPay) to 6.88% APR (without AutoPay). Variable rates
        currently from 2.25% APR (with AutoPay) to 6.43% (without AutoPay). Interest rates on
        variable rate loans are capped at either 8.95% or 9.95% depending on term of loan. Lowest
        variable rate of 2.25% APR assumes current 1 month LIBOR rate of 0.15% plus 2.35% margin
        minus 0.25% for AutoPay. If approved for a loan, the fixed or variable interest rate offered
        will depend on your credit history and the term of the loan and will be within the ranges of
        rates listed above. For the SoFi variable rate loan, the 1-month LIBOR index will adjust
        monthly and the loan payment will be re-amortized and may change monthly. APRs for variable
        rate loans may increase after origination if the LIBOR index increases. The SoFi 0.25%
        AutoPay interest rate reduction requires you to agree to make monthly principal and interest
        payments by an automatic monthly deduction from a savings or checking account. The benefit
        will discontinue and be lost for periods in which you do not pay by automatic deduction from
        a savings or checking account.
      </Font>
    </>
  ),
  mefa: (
    <>
      <Font type="disclaimer" className={styles.disclaimerText}>
        The interest rate and monthly payment on a MEFA variable rate Education
        Refinancing Loan may increase or decrease as its index, the 1-Month
        London Interbank Offered Rate (LIBOR) or its replacement index or
        reference rate, fluctuates.
      </Font>
    </>
  ),
}

export default disclaimers
